/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/unbound-method */
import { PayloadAction } from '@reduxjs/toolkit';
import { actions } from 'Slice/ChatBotSlice';
import { actions as helperActions } from 'Slice/HelperSlice';
import {
  Chat,
  ChatBotPrompts, ChatBotResponse, ChatFeedbackResponse,
} from 'Types/ChatBotTypes';
import {
  AskGilroyData, ChatBotPromptsPayload, ChatFeedback,
  ChatHistoryRequest, ClearChatRequest, CompanyChatBot, DocumentChatBot, GroupChatBot,
} from 'Types/RequestBodies';
import axios from 'Utils/Axios';
import { API } from 'Utils/Constants';
import { handleException } from 'Utils/UtilityFunctions';
import { call, put, takeLatest } from 'redux-saga/effects';

export function* generateEmail(dispatched: PayloadAction<AskGilroyData>) {
  const { payload } = dispatched;
  try {
    const response: ChatBotResponse = yield call(
      axios.post,
      API.GENERATE_EMAIL,
      payload,
    );
    if (response?.response?.popupText && response?.response?.showPlanPopup) {
      const {
        popupText, showPlanPopup, callToAction, contactUsEmail,
      } = response.response;
      const data = {
        popupText,
        showPlanPopup,
        callToAction: callToAction || '',
        contactUsEmail: contactUsEmail || '',
      };
      yield put(actions.setChatbotPopup(data));
    } else {
      const chat = response.response.result as Chat[];

      if (response?.status === true && chat[0]?.responseId) {
        yield put(actions.setChat(chat));
      } else {
        yield put(actions.setChatLoading(false));
        handleException();
      }
    }
  } catch (err) {
    console.log(err);
    yield put(actions.setChatLoading(false));
  }
}

export function* companyChatBot(dispatched: PayloadAction<CompanyChatBot>) {
  const { payload } = dispatched;
  try {
    const response: ChatBotResponse = yield call(
      axios.post,
      API.COMPANY_CHATBOT,
      payload,
    );
    if (response?.response?.popupText && response?.response?.showPlanPopup) {
      const {
        popupText, showPlanPopup, callToAction, contactUsEmail,
      } = response.response;
      const data = {
        popupText,
        showPlanPopup,
        callToAction: callToAction || '',
        contactUsEmail: contactUsEmail || '',
      };
      yield put(actions.setChatbotPopup(data));
    } else {
      const chat = response.response.result as Chat[];
      if (response?.status === true && chat) {
        yield put(actions.setChat(chat));
      } else {
        yield put(actions.setChatLoading(false));
        handleException();
      }
    }
  } catch (err) {
    console.log(err);
    yield put(actions.setChatLoading(false));
  }
}

export function* getChatBotPrompts(dispatched: PayloadAction<ChatBotPromptsPayload>) {
  const { payload } = dispatched;
  try {
    const response: ChatBotPrompts = yield call(
      axios.post,
      API.CHATBOT_PROMPTS,
      payload,
    );

    if (response?.status === true) {
      yield put(actions.setChatBotPrompts(response?.response));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* sendFeedback(dispatched: PayloadAction<ChatFeedback>) {
  const { payload } = dispatched;
  try {
    const response: ChatFeedbackResponse = yield call(
      axios.post,
      API.EMAIL_FEEDBACK,
      payload,
    );
    if (response?.status === true) {
      yield put(actions.setFeedbackSubmitted(payload?.responseId));
      yield put(helperActions.setNotification({
        message: 'Feedback Recieved',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
        getContainerEle: 'chatContainer',
      }));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* getChatHistory(dispatched: PayloadAction<ChatHistoryRequest>) {
  const { payload } = dispatched;
  try {
    const response: ChatBotResponse = yield call(
      axios.post,
      API.CHATBOT_HISTORY,
      payload,
    );

    if (response?.status === true) {
      yield put(actions.setChat(response?.response?.result as Chat[]));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* clearChatHistory(dispatched: PayloadAction<ClearChatRequest>) {
  const { payload } = dispatched;
  try {
    const response: ChatBotResponse = yield call(
      axios.post,
      API.CLEAR_CHAT_HISTORY,
      payload,
    );

    if (response?.status === true) {
      if (payload?.chatIds) {
        yield put(actions.setClearChatHistory(payload?.chatIds));
      } else {
        yield put(actions.setClearAllChatHistory());
      }
      yield put(helperActions.setNotification({
        message: payload?.chatIds ? 'Prompt Cleared Successfully' : 'History Cleared Successfully',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
        getContainerEle: 'chatContainer',
      }));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* groupChatBot(dispatched: PayloadAction<GroupChatBot>) {
  const { payload } = dispatched;
  try {
    const response: ChatBotResponse = yield call(
      axios.post,
      API.BUYER_GROUP_CHATBOT,
      payload,
    );
    if (response?.response?.popupText && response?.response?.showPlanPopup) {
      const {
        popupText, showPlanPopup, callToAction, contactUsEmail,
      } = response.response;
      const data = {
        popupText,
        showPlanPopup,
        callToAction: callToAction || '',
        contactUsEmail: contactUsEmail || '',
      };
      yield put(actions.setChatbotPopup(data));
    } else {
      const chat = response.response.result as Chat[];
      if (response?.status === true && chat) {
        yield put(actions.setChat(chat));
      } else {
        yield put(actions.setChatLoading(false));
        handleException();
      }
    }
  } catch (err) {
    console.log(err);
    yield put(actions.setChatLoading(false));
  }
}

export function* documentChatBot(dispatched: PayloadAction<DocumentChatBot>) {
  const { payload } = dispatched;
  try {
    const response: ChatBotResponse = yield call(
      axios.post,
      API.DOCUMENT_HUB_CHATBOT,
      payload,
    );
    if (response?.response?.popupText && response?.response?.showPlanPopup) {
      const {
        popupText, showPlanPopup, callToAction, contactUsEmail,
      } = response.response;
      const data = {
        popupText,
        showPlanPopup,
        callToAction: callToAction || '',
        contactUsEmail: contactUsEmail || '',
      };
      yield put(actions.setChatbotPopup(data));
    } else {
      const chat = response.response.result as Chat[];
      if (response?.status === true && chat) {
        yield put(actions.setChat(chat));
      } else {
        yield put(actions.setChatLoading(false));
        handleException();
      }
    }
  } catch (err) {
    console.log(err);
    yield put(actions.setChatLoading(false));
    handleException();
  }
}

export function* ChatBotSaga() {
  yield takeLatest(actions.generateEmail, generateEmail);
  yield takeLatest(actions.companyChatBot, companyChatBot);
  yield takeLatest(actions.groupChatBot, groupChatBot);
  yield takeLatest(actions.documentChatBot, documentChatBot);
  yield takeLatest(actions.getChatBotPrompts, getChatBotPrompts);
  yield takeLatest(actions.sendFeedback.type, sendFeedback);
  yield takeLatest(actions.getChatHistory.type, getChatHistory);
  yield takeLatest(actions.clearChatHistory.type, clearChatHistory);
}
